import { jsx as _jsx } from "react/jsx-runtime";
import { useTrackClickedEllipsisMenuButton } from "@air/analytics";
import { Ellipsis as EllipsisHorizontalIcon } from "@air/next-icons";
import { itemIsSelectedSelector } from "@air/redux-selected-items";
import { memo, useCallback, useMemo } from "react";
import { flushSync } from "react-dom";
import { useGetBoardCollectionGalleryAssetMenuOptions } from "~/components/BoardCollection/useGetBoardCollectionGalleryAssetMenuOptions";
import { CardAction } from "~/components/CardAction";
import { CardEllipsisMenu } from "~/components/Gallery/CardEllipsisMenu";
import { BOARD_COLLECTION_ASSET_CARD_SUB_MENU, BOARD_COLLECTION_ASSET_CARD_SUB_MENU_BUTTON } from "~/constants/testIDs";
import { useAirSelector } from "~/utils/ReduxUtils";
export const BoardCollectionGalleryAssetMenu = /*#__PURE__*/ memo((param)=>{
    let { clip, setIsMenuOpen } = param;
    var _menuProps_options;
    const { trackClickedEllipsisMenuButton } = useTrackClickedEllipsisMenuButton();
    const { getBoardCollectionAssetMenuOptions } = useGetBoardCollectionGalleryAssetMenuOptions({
        clip
    });
    const isSelected = useAirSelector((st)=>itemIsSelectedSelector(st, clip.id));
    const selectionMenuOptions = getBoardCollectionAssetMenuOptions();
    const ellipsisMenuOptions = getBoardCollectionAssetMenuOptions();
    const onMenuChange = useCallback((isOpen)=>{
        if (isOpen) {
            trackClickedEllipsisMenuButton({
                location: "asset-item"
            });
        }
        flushSync(()=>{
            setIsMenuOpen(isOpen);
        });
    }, [
        setIsMenuOpen,
        trackClickedEllipsisMenuButton
    ]);
    const menuProps = useMemo(()=>({
            options: isSelected && selectionMenuOptions.length ? selectionMenuOptions : ellipsisMenuOptions
        }), [
        ellipsisMenuOptions,
        isSelected,
        selectionMenuOptions
    ]);
    if (!(menuProps === null || menuProps === void 0 ? void 0 : (_menuProps_options = menuProps.options) === null || _menuProps_options === void 0 ? void 0 : _menuProps_options.length)) {
        return null;
    }
    return /*#__PURE__*/ _jsx(CardEllipsisMenu, {
        title: "More asset options",
        menuProps: menuProps,
        onMenuChange: onMenuChange,
        actionSheetTestId: BOARD_COLLECTION_ASSET_CARD_SUB_MENU,
        trigger: /*#__PURE__*/ _jsx(CardAction, {
            "data-testid": BOARD_COLLECTION_ASSET_CARD_SUB_MENU_BUTTON,
            icon: /*#__PURE__*/ _jsx(EllipsisHorizontalIcon, {
                className: "size-4"
            })
        })
    });
});
BoardCollectionGalleryAssetMenu.displayName = "BoardCollectionGalleryAssetMenu";
